import React from "react";
var __jsx = React.createElement;
import stl from "./HeroArea.module.css";
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
var HeroArea = function HeroArea() {
  var _useTranslation = useTranslation(["web_city"]),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.CHA_container
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.CHA_text
  }, /*#__PURE__*/React.createElement("p", {
    className: stl.subTitle
  }, t("أوسع تشكيلة", {
    ns: "web_city"
  })), /*#__PURE__*/React.createElement("p", {
    className: stl.title
  }, t("سيارات في السعودية", {
    ns: "web_city"
  })), /*#__PURE__*/React.createElement("p", null, t("جديد أو مستعمل وحنا نوصلها لين عندك", {
    ns: "web_city"
  }))), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/city/biggest_collection.webp",
    alt: "biggest collection of cars image",
    loading: "eager",
    width: "510px",
    height: "280px"
  })));
};
export default HeroArea;